'use client'

import styled from 'styled-components'

import theme from '@/src/config/theme'

export const Component = styled.div`
  cursor: pointer;
  font-size: 1.125rem;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: 4px;

  &:hover {
    color: ${theme.colors.primary};
  }
`
